/** React effect cleanups must be functions; non-functions throw TypeError when unmounted. */
export function isEffectCleanupTypeError(reason: unknown): boolean {
    if (!(reason instanceof TypeError)) {
        return false
    }

    return / is not a function$/.test(reason.message)
}
